<template>
  <div :class="$style.icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <circle
        :class="$style[bgClass]"
        cx="16"
        cy="16"
        r="16"
      />
      <path
        :class="$style[fillClass]"
        d="M24.3,22.9c-0.2,0-0.4-0.1-0.6-0.2L15,16.6V5.5c0-0.6,0.4-1,1-1s1,0.4,1,1v10.1l7.9,5.5
  	c0.5,0.3,0.6,0.9,0.3,1.4C24.9,22.7,24.6,22.9,24.3,22.9z"
      />
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
import iconsMixins from './../icons.mixins'

export default {
  name: 'ClockIcon',

  mixins: [iconsMixins],

  data () {
    return {
      defaultStatusFill: {
        icon: 'white',
        bg: 'orange'
      }
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';

.icon {
  position: relative;
  width: rem(28);
  height: rem(28);
  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}

@each $color, $value in $colors {
  .bg#{$color} {
    fill: $value;
  }
  .fill#{$color} {
    fill: $value;
  }
}
</style>
